/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_CatInputs */

const en_svc_retainer_cat = /** @type {(inputs: Svc_Retainer_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const ar_svc_retainer_cat = /** @type {(inputs: Svc_Retainer_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#رعاية`)
};

const bn_svc_retainer_cat = /** @type {(inputs: Svc_Retainer_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const de_svc_retainer_cat = /** @type {(inputs: Svc_Retainer_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const es_svc_retainer_cat = /** @type {(inputs: Svc_Retainer_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const fr_svc_retainer_cat = /** @type {(inputs: Svc_Retainer_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const pt_svc_retainer_cat = /** @type {(inputs: Svc_Retainer_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const zh_svc_retainer_cat = /** @type {(inputs: Svc_Retainer_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const tr_svc_retainer_cat = /** @type {(inputs: Svc_Retainer_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const ru_svc_retainer_cat = /** @type {(inputs: Svc_Retainer_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const pl_svc_retainer_cat = /** @type {(inputs: Svc_Retainer_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

/**
* | output |
* | --- |
* | "#CARE" |
*
* @param {Svc_Retainer_CatInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_retainer_cat = /** @type {((inputs?: Svc_Retainer_CatInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_CatInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_cat(inputs)
	if (locale === "bn") return bn_svc_retainer_cat(inputs)
	if (locale === "de") return de_svc_retainer_cat(inputs)
	if (locale === "es") return es_svc_retainer_cat(inputs)
	if (locale === "fr") return fr_svc_retainer_cat(inputs)
	if (locale === "pt") return pt_svc_retainer_cat(inputs)
	if (locale === "zh") return zh_svc_retainer_cat(inputs)
	if (locale === "tr") return tr_svc_retainer_cat(inputs)
	if (locale === "ru") return ru_svc_retainer_cat(inputs)
	if (locale === "pl") return pl_svc_retainer_cat(inputs)
	return en_svc_retainer_cat(inputs)
});